import React, { useEffect, useState } from 'react';
import { Container, Paper, Title, Text, Group, Button } from '@mantine/core';
import { Link, useNavigate } from 'react-router-dom';
import { RoutePaths } from '../../../router/RoutePaths';

const OrderSubmitted: React.FC = () => {
  const [seconds, setSeconds] = useState<number>(30);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((s) => s - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (seconds <= 0) {
      navigate(RoutePaths.publicPaths.landing, { replace: true });
    }
  }, [seconds, navigate]);

  return (
    <Container size="sm" style={{ paddingTop: '2rem', paddingBottom: '2rem' }}>
      <Paper radius="lg" p="xl" shadow="md">
        <Title order={3} style={{ marginBottom: '0.75rem' }}>Thank you</Title>
        <Text style={{ marginBottom: '0.5rem' }}>
          Home of the Innocents has recieved the details of the items you have retrieved. No further action is necessary.
        </Text>
        <Text>
          This page will reset in {Math.max(seconds, 0)} seconds.
        </Text>
        <Group position="right" style={{ marginTop: '1rem' }}>
          <Button component={Link} to={RoutePaths.publicPaths.landing} variant="outline">
            Go back now
          </Button>
        </Group>
      </Paper>
    </Container>
  );
};

export default OrderSubmitted;
